module.exports = __webpack_public_path__ + "img/Einschulungsgrinsen.86a1bc4d.svg";